const VALIDATION_STATUS = 400;
const MAX_MESSAGE_LENGTH = 300;

const TECHNICAL_KEYS = new Set([
  'status',
  'statusText',
  'timestamp',
  'path',
  'trace',
  'stackTrace',
  'code',
  'exception',
  'error',
  'text',
  'url',
  'name',
  'ok',
  'headers',
  'developperMessage',
  'developerMessage',
]);

function isDisplayableMessage(value: string): boolean {
  const trimmed = value.trim();

  return (
    trimmed.length > 0 &&
    trimmed.length <= MAX_MESSAGE_LENGTH &&
    !trimmed.includes('<')
  );
}

function toMessageList(value: unknown): string[] {
  if (typeof value === 'string') {
    return isDisplayableMessage(value) ? [value.trim()] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(item => toMessageList(item));
  }

  return [];
}

function collectFieldMessages(body: Record<string, unknown>): string[] {
  return Object.keys(body)
    .filter(key => !TECHNICAL_KEYS.has(key))
    .flatMap(key => toMessageList(body[key]));
}

export function extractLoanApiErrorMessages(error: unknown): string[] {
  const httpError = error as { status?: unknown; error?: unknown };

  if (httpError?.status !== VALIDATION_STATUS) {
    return [];
  }

  const body = httpError.error;

  if (typeof body === 'string') {
    return toMessageList(body);
  }

  if (!body || typeof body !== 'object') {
    return [];
  }

  const record = body as Record<string, unknown>;
  const informations = record['informations'] as Record<string, unknown>;

  const messages = [
    ...collectFieldMessages(record),
    ...(informations ? collectFieldMessages(informations) : []),
  ];

  return Array.from(new Set(messages));
}
